module.exports = __webpack_public_path__ + "static/img/smplogonew.002dcda.png";